// import {
//   IonPage,
//   IonHeader,
//   IonToolbar,
//   IonButtons,
//   IonMenuButton,
//   IonTitle,
//   IonContent,
//   IonSelect,
//   IonItem,
//   IonSelectOption,
//   IonLoading,
// } from "@ionic/react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Container,
//   FormControl,
//   FormControlLabel,
//   IconButton,
//   List,
//   AlertTitle,
//   ListItem,
//   ListItemText,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   InputLabel,
//   MenuItem,
//   Select,
//   SelectChangeEvent,
// } from "@mui/material";
// import Alert from "@mui/material/Alert";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router";
// import { baseUrl, config, getUser, getUserData, requestID } from "../../common/utils";
// import { Link } from "react-router-dom";
// import { Style } from "@mui/icons-material";
// import { useBusinessContext } from "../../BusinessContext";
// import styles from "./PaymentApproval.module.css";
// export type User = {
//   accountName: string;
//   accountNumber: number;
//   activeloans: number;
//   area: string;
//   bankName: string;
//   businessAddress: string;
//   bvn: number;
//   churchAddress: string;
//   dob: string; // Date of birth as a string
//   email: string;
//   firstName: string;
//   id: number;
//   lastName: string;
//   lga: string;
//   middleName: string;
//   nextOfKin: string;
//   nextOfKinAddress: string;
//   nextOfKinPhone: string;
//   nextOfKinRelationship: string;
//   parish: string;
//   password: string; // This should not be displayed or handled in the UI
//   pastorName: string;
//   pastorPhone: string;
//   phone: string;
//   province: string;
//   residentialAddress: string;
//   savingAmount: string;
//   securityAnswer1: string;
//   securityAnswer2: string;
//   securityQuestion1: string;
//   securityQuestion2: string;
//   status: number;
//   titles: string;
//   unitHeadName: string;
//   unitHeadPhone: string;
//   user_id: string;
//   zone: string;
// };

// const LoanApprovedList = () => {
//   const user_id = getUserData()?.user_id;
//   const { selectedBusiness} = useBusinessContext()
//   // const { name } = useParams<{ name: string }>();
//   const location = useLocation();
//   const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Payment Approval";
//   const url = baseUrl() ; //"http://localhost/rmfwarri";
//   const [users, setUsers] = useState<any>([]);
//   const [paymentList, setPaymentList] = useState<any>([]);

//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [status, setStatus] = useState({ loading: false, error: false });
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openDialogO, setOpenDialogO] = useState(false);
//   const [selectedAmount, setSelectedAmount] = useState("");

//   const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
//   const [actionType, setActionType] = useState<"approve" | "reject" | null>(
//     null
//   );
//   const [userType, setUserType] = useState("");
//   const [showAlert, setShowAlert] = useState<boolean>(false);
//   const [alertMsg, setAlertMsg] = useState<string>("");

//   const onShowAlert = () => {
//     setShowAlert(true);
//     setTimeout(() => setShowAlert(false), 5000);
//   };

//   const fetchLoanApplications = async () => {

//     //console.log(selectedBusiness);
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("business_id", selectedBusiness.business_id);
//     formData.append("branch_id", selectedBusiness.branch_id);

//       const response = await axios.post(
//         url+ "applyloans/getPaymentApprovalList_caas",
//         formData,
//         config
//       );
//       console.log(response);
//       const { data } = response.data;
//       setUsers(data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//       setLoading(false);
//     }
//   };

  

//   const filteredUsers = users?.filter((user) =>
//     user.type.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleChangePage = (
//     event: React.MouseEvent<HTMLButtonElement> | null,
//     newPage: number
//   ) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const emptyRows =
//     rowsPerPage - Math.min(rowsPerPage, users?.length - page * rowsPerPage);

//     const handleApproveO = async (
//       activityID: string,
//       userType: string,
//       amount: string,
//       payAccount:string,
//     ) => {
//       console.log(payAccount)
//       setStatus({ loading: true, error: false });
//       try {
//         const formData = new FormData();
//         formData.append("requestID", requestID());
//         formData.append("activityID", activityID);
//         formData.append("amount", amount);
//         formData.append("type", userType);
//         formData.append("business_id", selectedBusiness.business_id);
//         formData.append("branch_id", selectedBusiness.branch_id);
  
//         // formData.append("amount", amount);
//         formData.append("sourceLedger", payAccount);
        
  

//         const response = await axios.post(
//           baseUrl() + "users/postingApproval",
//           formData,
//           config
//         );

// console.log(response)
    
//          const {data}  = response
//          console.log(data.status)
//          if (data.status == true) {
//           setStatus({ loading: false, error: false });
//           setAlertMsg(response.data.message);
//           onShowAlert();
//           fetchLoanApplications();
//         } else {
//           setAlertMsg(response.data.message);
//           onShowAlert();
//           setStatus({ loading: false, error: true });
//         }
//         // fetchLoanApplications()
//         // if(response.data.status == "true"){
//         //         setUsers(users.map(user =>
//         //   user.loanID === userId ? { ...user, status: '1' } : user
//         // ));
//         // }
//       } catch (error) {
//         console.error("Error approving loan:", error);
//         setStatus({ loading: false, error: true });
//       }
//     };


//   const handleApprove = async (
//     userId: string,
//     userType: string,
//     amount: string
//   ) => {
//    // alert('handleApprove:AL:' + userType + "" + amount + " " + userId);
//     console.log('handleApprove : ' + userId);
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("user_id", userId);
//       formData.append("amount", amount);
     
//       formData.append("postType", userType);
//       formData.append("business_id", selectedBusiness.business_id);
//       formData.append("branch_id", selectedBusiness.branch_id);

//       const response = await axios.post(
//         baseUrl() + "users/postingApproval_caas_audit",
//         formData,
//         config
//       );
//       console.log(response);
//       fetchLoanApplications();
//       // fetchLoanApplications()
//       // if(response.data.status == "true"){
//       //         setUsers(users.map(user =>
//       //   user.loanID === userId ? { ...user, status: '1' } : user
//       // ));
//       // }
//     } catch (error) {
//       console.error("Error approving loan:", error);
//     }
//   };

//   const handleReject = async (userId: string) => {
//     try {
//       await axios.post(`${baseUrl()}/api/reject-loan/${userId}`); // Replace with your API endpoint
//       // Refresh the list after rejecting
//       // setUsers(users.map(user =>
//       //   user.id === userId ? { ...user, status: 'Rejected' } : user
//       // ));
//     } catch (error) {
//       console.error("Error rejecting loan:", error);
//     }
//   };


//   const getPaymentLedgers = async () => {
   
//     setStatus({ loading: true, error: false });
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("business_id", selectedBusiness.business_id);
//       formData.append("branch_id", selectedBusiness.branch_id);
 
//       const response = await axios.post(
//         baseUrl() + "ledgers/getPaymentLedgers",
//         formData,
//         config
//       );

// console.log(response)
  
//        const {data}  = response.data
//        setPaymentList(data);
//        console.log(data.status)
//        if (data.status == true) {
//         setStatus({ loading: false, error: false });
//         setAlertMsg(response.data.message);
        
//         onShowAlert();
//        // fetchLoanApplications();
//       } else {
//         setAlertMsg(response.data.message);
//         onShowAlert();
//         setStatus({ loading: false, error: true });
//       }
//       // fetchLoanApplications()
//       // if(response.data.status == "true"){
//       //         setUsers(users.map(user =>
//       //   user.loanID === userId ? { ...user, status: '1' } : user
//       // ));
//       // }
//     } catch (error) {
//       console.error("Error approving loan:", error);
//       setStatus({ loading: false, error: true });
//     }
//   };


//   const handleOpenDialogO = (
//     userId: string,
//     action: "approve" | "reject",
//     userType: string,
//     amount: string
//   ) => {
//     setSelectedUserId(userId);
//     setActionType(action);
//     setOpenDialogO(true);
//     setUserType(userType);
//     setSelectedAmount(amount);
//   };


//   const handleOpenDialog = (
//     userId: string,
//     action: "approve" | "reject",
//     userType: string,
//     amount: string
//   ) => {
//     setSelectedUserId(userId);
//     setActionType(action);
//     setOpenDialog(true);
//     setUserType(userType);
//     setSelectedAmount(amount);
//   };

//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setOpenDialogO(false);
//     setSelectedUserId(null);
//     setActionType(null);
//     setUserType("");
//     setSelectedAmount("");
//   };


//   const handleConfirmActionO = () => {
//    // alert(selectedAmount);
//     //alert(userType);
//    // alert(selectedUserId);
//    // alert(actionType);

// if (!paywithValue){

// alert('Please Select An Account to Pay With !');
// }

//     if (actionType && selectedUserId && userType && selectedAmount && paywithValue) {
//       if (actionType === "approve") {
//        // alert(paywithValue);
//        handleApproveO(selectedUserId,userType,selectedAmount,paywithValue);
//       } else if (actionType === "reject") {
//         handleReject(selectedUserId);
//       }
//       handleCloseDialog();
//     }
//   };



//   const handleConfirmAction = () => {
//     if (actionType && selectedUserId && userType && selectedAmount) {
//       if (actionType === "approve") {
//       //alert(paywithValue);
//           handleApprove(selectedUserId,userType,selectedAmount);
//       } else if (actionType === "reject") {
//         handleReject(selectedUserId);
//       }
//       handleCloseDialog();
//     }
//   };

//   const [paywithValue, setPaywithValue] = useState<string>("");

//   useEffect(() => {
//     fetchLoanApplications();
//     getPaymentLedgers();
//     return () => {};
//   }, []);
//   //console.log(;

//   return (
//     <IonPage>
//       <IonHeader>
//         <IonToolbar className={styles.headerToolbar}>
//           <IonButtons slot="start">
//             <IonMenuButton />
//           </IonButtons>
//           <IonTitle>{name}</IonTitle>
//         </IonToolbar>
//       </IonHeader>

//       <IonContent fullscreen>
//         <Box
//           sx={{
//             paddingTop: "20px",
//             "& > :not(style)": { m: 1 },
//           }}
//         >
//           {/* <Link to={"/folder/loanRunning/loanRunning"}>
//             <Button
//               variant="contained"
//               color="primary"
//               slot="end"
//               sx={{ m: 1, mr: 1 }}
//             >
//               View Active Loans
//             </Button>
//             <Divider orientation="horizontal" flexItem />
//           </Link> */}
//         </Box>

//         {/* <Container component="main" sx={{ mt: 4, mb: 2 }}> */}
//         <Paper elevation={3} sx={{ padding: 2 }}>
//           <TextField
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             label="Search by Type"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             <>
//               <TableContainer component={Paper} sx={{ mt: 2 }}>
//               {showAlert && (
//           <Alert severity={status.error ? "error" : "success"}>
//             <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
//             {alertMsg?.toUpperCase()}
//           </Alert>
//         )}
//                 <Table sx={{ minWidth: 700 }}>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>S/N</TableCell>
//                       <TableCell>Purpose</TableCell>
//                       <TableCell>Details</TableCell>
//                       <TableCell> Amount</TableCell>
//                       <TableCell>Type</TableCell>

//                       <TableCell>Actions</TableCell>
//                     </TableRow>
//                   </TableHead>
                 

                
//                   <TableBody>
//                     {filteredUsers
//                       ?.slice(
//                         page * rowsPerPage,
//                         page * rowsPerPage + rowsPerPage
//                       )
//                       .map((user, i: number) =>
                      
//                       {   const roleID = getUser().loginData.roleID ;
//                         if (roleID == 3 && (user.type === "accountPost" || user.type === "tellerPost")) {
//                           return (
                        
//                             <TableRow key={i}>
//                               <TableCell>{page * rowsPerPage + i + 1}</TableCell>
//                               <TableCell>{user.purpose}</TableCell>
//                               <TableCell>{user.activityDetails}</TableCell>
//                               <TableCell>{user.amount}</TableCell>
//                               <TableCell>{user.type}</TableCell>
//                               <TableCell>
                             
                                
                           
//                                <Box sx={{ display: "flex", alignItems: "center" }}>
//                                   {user.type == "accountPost" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"secondary"}
//                                           onClick={() =>
//                                             handleOpenDialog(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Accountant
//                                         </Button>
                                    
//                                       )}
//                                     </>
//                                   )}
//                                   {user.type == "tellerPost" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"secondary"}
//                                           onClick={() =>
//                                             handleOpenDialog(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Teller
//                                         </Button>
                              
//                                       )}
//                                     </>
//                                   )}
//                                     {user.type == "cashWithdrawal" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"warning"}
//                                           onClick={() =>
//                                             handleOpenDialogO(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Cash Withdrawal
//                                         </Button>
                                 
//                                       )}
//                                     </>
//                                   )}
//                                     {user.type == "memberWithdrawal" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"warning"}
//                                           onClick={() =>
//                                             handleOpenDialogO(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Member Withdrawal
//                                         </Button>
                              
//                                       )}
//                                     </>
//                                   )}
//                                     {user.type == "loanPost" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"warning"}
//                                           onClick={() =>
//                                             handleOpenDialogO(
//                                               user.activityID,
//                                               //user.user_id,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Loan Disbursement
//                                         </Button>
                                    
//                                       )}
//                                     </>
//                                   )}
//                                     {user.type == "loanClearoff" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"warning"}
//                                           onClick={() =>
//                                             handleOpenDialogO(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Approve Loan Clear Off
//                                         </Button>
//                                       )}
//                                     </>
//                                   )}
//                                     {user.type == "memberWithdrawaWithLoan" && (
//                                     <>
//                                       {user?.status == 1 && (
//                                         <Button
//                                           variant="contained"
//                                           color={"warning"}
//                                           onClick={() =>
//                                             handleOpenDialogO(
//                                               user.activityID,
//                                               "approve",
//                                               user.type,
//                                               user.amount
//                                             )
//                                           }
//                                           sx={{ mr: 1 }}
//                                         >
//                                           Member Withdrawal with Loan
//                                         </Button>
                                 
//                                       )}
//                                     </>
//                                   )}
//                               </Box>
                             
                              
               
    
//                                 {emptyRows < 0 && (
//                                   <TableRow style={{ height: 53 * emptyRows }}>
//                                     <TableCell colSpan={3} />
//                                   </TableRow>
//                                 )}
//                               </TableCell>
//                             </TableRow>
//                           )
//                       }
//                       if (roleID == 4) {
//                         return (
                      
//                           <TableRow key={i}>
//                             <TableCell>{page * rowsPerPage + i + 1}</TableCell>
//                             <TableCell>{user.purpose}</TableCell>
//                             <TableCell>{user.activityDetails}</TableCell>
//                             <TableCell>{user.amount}</TableCell>
//                             <TableCell>{user.type}</TableCell>
//                             <TableCell>
                           
                              
                         
//                              <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 {user.type == "accountPost" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialog(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Accountant
//                                       </Button>
                                  
//                                     )}
//                                   </>
//                                 )}
//                                 {user.type == "tellerPost" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialog(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Teller
//                                       </Button>
                            
//                                     )}
//                                   </>
//                                 )}
//                                   {user.type == "cashWithdrawal" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialogO(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Cash Withdrawal
//                                       </Button>
                               
//                                     )}
//                                   </>
//                                 )}
//                                   {user.type == "memberWithdrawal" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialogO(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Member Withdrawal
//                                       </Button>
                            
//                                     )}
//                                   </>
//                                 )}
//                                   {user.type == "loanPost" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialogO(
//                                             user.activityID,
//                                             //user.user_id,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Loan Disbursement
//                                       </Button>
                                  
//                                     )}
//                                   </>
//                                 )}
//                                   {user.type == "loanClearoff" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialogO(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Approve Loan Clear Off
//                                       </Button>
//                                     )}
//                                   </>
//                                 )}
//                                   {user.type == "memberWithdrawaWithLoan" && (
//                                   <>
//                                     {user?.status == 1 && (
//                                       <Button
//                                         variant="contained"
//                                         color={"warning"}
//                                         onClick={() =>
//                                           handleOpenDialogO(
//                                             user.activityID,
//                                             "approve",
//                                             user.type,
//                                             user.amount
//                                           )
//                                         }
//                                         sx={{ mr: 1 }}
//                                       >
//                                         Member Withdrawal with Loan
//                                       </Button>
                               
//                                     )}
//                                   </>
//                                 )}
//                             </Box>
                           
                            
             
  
//                               {emptyRows < 0 && (
//                                 <TableRow style={{ height: 53 * emptyRows }}>
//                                   <TableCell colSpan={3} />
//                                 </TableRow>
//                               )}
//                             </TableCell>
//                           </TableRow>
//                         )
//                     }
//                     }
//                 )}
//                   </TableBody>

                
 
//                 </Table>
//               </TableContainer>
//               <TablePagination
//                 rowsPerPageOptions={[10, 25, 50]}
//                 component="div"
//                 count={filteredUsers?.length ?? 0}
//                 // count={users?.length ?? 0}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//               />
//             </>
//           )}
//         </Paper>
//         {/* </Container> */}
//         <Dialog
//           open={openDialogO}
//           onClose={handleCloseDialog}
//           aria-labelledby="confirmation-dialog-title"
//           aria-describedby="confirmation-dialog-description"
//         >
//           <DialogTitle id="confirmation-dialog-title">
//             Confirm Action
//           </DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to {actionType} this Post Request ?
//             </Typography>
// <Box   sx={{
//               display: "flex",
//               alignItems: "center",
//             width:'90%',
            
  
//               marginTop:'1%',
//              // marginLeft:'40%',
//               "& > :not(style)": { m: 4 },
//             }}>



            
//             <FormControl fullWidth>
//               <InputLabel id="demo-simple-select-label">Select Account to Pay With</InputLabel>
//               <Select
//                 labelId="demo-simple-select-label"
//                 id="demo-simple-select"
//                 value={paywithValue}
//                 label="Select Account to Pay With"
//                 onChange={(event: SelectChangeEvent) => {
//                   setPaywithValue(event.target.value as string);
//                 }}
//               >

//                     {paymentList?.map((paymentListx) => {
//                                   return (
//                                     <MenuItem
//                                       key={paymentListx.id}
//                                       value={
//                                         paymentListx.sn
//                                       }
//                                     >
//                                       {paymentListx.name}
//                                     </MenuItem>
//                                   );
//                                 })}

 
//               </Select>
//             </FormControl>

//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} color="primary">
//               Cancel
//             </Button>
//             <Button
//               onClick={handleConfirmActionO}
//               color={actionType === "approve" ? "success" : "error"}
//               autoFocus
//             >
//               {actionType === "approve" ? "Approve" : "Reject"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog}
//           aria-labelledby="confirmation-dialog-title"
//           aria-describedby="confirmation-dialog-description"
//         >
//           <DialogTitle id="confirmation-dialog-title">
//             Confirm Action
//           </DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to {actionType} this Request ?
//             </Typography>
// <Box   sx={{
//               display: "flex",
//               alignItems: "center",
//             width:'90%',
            
  
//               marginTop:'1%',
//              // marginLeft:'40%',
//               "& > :not(style)": { m: 4 },
//             }}>



            
           
//             </Box>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} color="primary">
//               Cancel
//             </Button>
//             <Button
//               onClick={handleConfirmAction}
//               color={actionType === "approve" ? "success" : "error"}
//               autoFocus
//             >
//               {actionType === "approve" ? "Approve" : "Reject"}
//             </Button>
//           </DialogActions>
//         </Dialog>

        
//         <IonLoading
//             message="Logging..."
//             spinner="circles"
//             isOpen={status.loading}
//           />

//       </IonContent>
//     </IonPage>
//   );
// };

// export default LoanApprovedList;


import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonLoading,
} from "@ionic/react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Paper,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  Select,
  Fade,
  Slide,
  Zoom,
  Grow,
  alpha,
  useTheme,
  IconButton,
  Collapse,
  Chip,
  Alert,
  AlertTitle,
} from "@mui/material";
import {
  Search as SearchIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  AccountBalance as AccountIcon,
  Payment as PaymentIcon,
  Warning as WarningIcon,
  Download as DownloadIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { baseUrl, config, getUser, getUserData, requestID } from "../../common/utils";
 import styles from "./PaymentApproval.module.css";
import { useBusinessContext } from "../../context/business-context";

interface PaymentActivity {
  activityID: string;
  purpose: string;
  activityDetails: string;
  amount: string;
  type: string;
  status: number;
}

interface PaymentLedger {
  id: string;
  sn: string;
  name: string;
}

const PaymentApproval: React.FC = () => {
  const user_id = getUserData()?.user_id;
  const { selectedBusiness } = useBusinessContext();
  const location = useLocation();
  const theme = useTheme();
  const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Payment Approval";
  
  const [users, setUsers] = useState<PaymentActivity[]>([]);
  const [paymentList, setPaymentList] = useState<PaymentLedger[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogO, setOpenDialogO] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [actionType, setActionType] = useState<"approve" | "reject" | null>(null);
  const [userType, setUserType] = useState("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [paywithValue, setPaywithValue] = useState<string>("");

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const fetchLoanApplications = async () => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "applyloans/getPaymentApprovalList_caas",
        formData,
        config
      );
      
      const { data } = response.data;
      setUsers(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching payment applications:", error);
      setLoading(false);
    }
  };

  const filteredUsers = users?.filter((user) => {
    user.type.toLowerCase().includes(searchTerm.toLowerCase())
  alert(`now filtering user by ${searchTerm}`)
  }
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApproveO = async (activityID: string, userType: string, amount: string, payAccount: string) => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("activityID", activityID);
      formData.append("amount", amount);
      formData.append("type", userType);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);
      formData.append("sourceLedger", payAccount);

      const response = await axios.post(
        baseUrl() + "users/postingApproval",
        formData,
        config
      );

      if (response.data.status === true) {
        setStatus({ loading: false, error: false });
        setAlertMsg(response.data.message);
        onShowAlert();
        fetchLoanApplications();
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      console.error("Error approving payment:", error);
      setStatus({ loading: false, error: true });
    }
  };

  const handleApprove = async (userId: string, userType: string, amount: string) => {
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("user_id", userId);
      formData.append("amount", amount);
      formData.append("postType", userType);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "users/postingApproval_caas_audit",
        formData,
        config
      );
      
      fetchLoanApplications();
    } catch (error) {
      console.error("Error approving payment:", error);
    }
  };

  const handleReject = async (userId: string) => {
    try {
      await axios.post(`${baseUrl()}api/reject-loan/${userId}`);
      // Refresh the list after rejecting
      fetchLoanApplications();
    } catch (error) {
      console.error("Error rejecting loan:", error);
    }
  };

  const getPaymentLedgers = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);

      const response = await axios.post(
        baseUrl() + "ledgers/getPaymentLedgers",
        formData,
        config
      );
      console.log("Payment Ledgers Response:", response.data);

      const { data } = response.data;
      setPaymentList(data);
      
      if (data?.status === true) {
        setStatus({ loading: false, error: false });
      } else {
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      console.error("Error fetching payment ledgers:", error);
      setStatus({ loading: false, error: true });
    }
  };

  const handleOpenDialogO = (userId: string, action: "approve" | "reject", userType: string, amount: string) => {
    setSelectedUserId(userId);
    setActionType(action);
    setOpenDialogO(true);
    setUserType(userType);
    setSelectedAmount(amount);
  };

  const handleOpenDialog = (userId: string, action: "approve" | "reject", userType: string, amount: string) => {
    setSelectedUserId(userId);
    setActionType(action);
    setOpenDialog(true);
    setUserType(userType);
    setSelectedAmount(amount);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenDialogO(false);
    setSelectedUserId(null);
    setActionType(null);
    setUserType("");
    setSelectedAmount("");
    setPaywithValue("");
  };

  const handleConfirmActionO = () => {
    if (!paywithValue && actionType === "approve") {
      setAlertMsg("Please select an account to pay with!");
      onShowAlert();
      return;
    }

    if (actionType && selectedUserId && userType && selectedAmount) {
      if (actionType === "approve") {
        handleApproveO(selectedUserId, userType, selectedAmount, paywithValue);
      } else if (actionType === "reject") {
        handleReject(selectedUserId);
      }
      handleCloseDialog();
    }
  };

  const handleConfirmAction = () => {
    if (actionType && selectedUserId && userType && selectedAmount) {
      if (actionType === "approve") {
        handleApprove(selectedUserId, userType, selectedAmount);
      } else if (actionType === "reject") {
        handleReject(selectedUserId);
      }
      handleCloseDialog();
    }
  };

  const getButtonColor = (type: string) => {
    switch (type) {
      case "accountPost": return "primary";
      case "tellerPost": return "secondary";
      case "cashWithdrawal": return "warning";
      case "memberWithdrawal": return "info";
      case "loanPost": return "success";
      case "loanClearoff": return "error";
      case "memberWithdrawaWithLoan": return "warning";
      default: return "primary";
    }
  };

  const getButtonVariant = (type: string) => {
    return "contained";
  };

  useEffect(() => {
    fetchLoanApplications();
    getPaymentLedgers();
  }, []);

  const roleID = getUser().loginData.roleID;

  return (
    <IonPage className={styles.page}>
      <IonHeader>
        <IonToolbar className={styles.headerToolbar}>
          <IonButtons slot="start">
            <IonMenuButton className={styles.menuButton} />
          </IonButtons>
          <IonTitle className={styles.title}>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className={styles.content}>
        {/* Alert Notification */}
        <Collapse in={showAlert} className={styles.alertContainer}>
          <Alert severity={status.error ? "error" : "success"} className={styles.alert}>
            <AlertTitle>{status.error ? "Error" : "Success"}</AlertTitle>
            {alertMsg.toUpperCase()}
          </Alert>
        </Collapse>

        <Container maxWidth="lg" className={styles.container}>
          <Grow in={true} timeout={800}>
            <Paper elevation={0} className={styles.paper}>
              {/* Header Section */}
              <Slide direction="down" in={true} timeout={500}>
                <Box className={styles.header}>
                  <Box className={styles.headerContent}>
                    <PaymentIcon className={styles.headerIcon} />
                    <Typography variant="h3" className={styles.headerTitle}>
                      Payment Approval
                    </Typography>
                  </Box>
                  <Typography variant="body1" className={styles.headerSubtitle}>
                    Review and approve pending payment requests
                  </Typography>
                </Box>
              </Slide>

              {/* Search Section */}
              <Fade in={true} timeout={700}>
                <Box className={styles.searchSection}>
                  <Box className={styles.searchContainer}>
                    {/* <SearchIcon className={styles.searchIcon} /> */}
                    <TextField
                      label="Search by Type"
                      variant="outlined"
                      fullWidth
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className={styles.searchField}
                      InputProps={{
                        className: styles.searchInput,
                      }}
                    />
                  </Box>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={fetchLoanApplications}
                    className={styles.refreshButton}
                    startIcon={<RefreshIcon />}
                  >
                    Refresh
                  </Button>
                </Box>
              </Fade>

              {/* Results Section */}
              {loading ? (
                <Box className={styles.loadingContainer}>
                  <CircularProgress size={60} thickness={4} className={styles.spinner} />
                  <Typography variant="h6" className={styles.loadingText}>
                    Loading payment requests...
                  </Typography>
                </Box>
              ) : filteredUsers?.length > 0 ? (
                <Zoom in={true} timeout={1000}>
                  <Box className={styles.resultsSection}>
                    <Box className={styles.resultsHeader}>
                      <Typography variant="h6" className={styles.resultsTitle}>
                        Pending Approvals
                      </Typography>
                      <Chip
                        label={`${filteredUsers?.length} requests found`}
                        color="primary"
                        variant="outlined"
                        className={styles.resultsCount}
                      />
                    </Box>

                    <TableContainer component={Paper} elevation={0} className={styles.tableContainer}>
                      <Table className={styles.table}>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>S/N</TableCell>
                            <TableCell className={styles.tableCell}>
                              <AccountIcon className={styles.columnIcon} />
                              Purpose
                            </TableCell>
                            <TableCell className={styles.tableCell}>Details</TableCell>
                            <TableCell className={styles.tableCell}>Amount</TableCell>
                            <TableCell className={styles.tableCell}>Type</TableCell>
                            <TableCell className={styles.tableCell}>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredUsers
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((user, i) => {
                              if (
                                (roleID == 3 && (user.type === "accountPost" || user.type === "tellerPost")) ||
                                (roleID == 4 && user.status == 1)
                              ) {
                                return (
                                  <Grow in={true} timeout={300 + (i * 100)} key={i}>
                                    <TableRow className={styles.tableRow}>
                                      <TableCell className={styles.tableCell}>{page * rowsPerPage + i + 1}</TableCell>
                                      <TableCell className={styles.tableCell}>{user.purpose}</TableCell>
                                      <TableCell className={styles.tableCell}>{user.activityDetails}</TableCell>
                                      <TableCell className={styles.tableCell}>
                                        <Chip
                                          label={`₦${user.amount}`}
                                          color="primary"
                                          variant="filled"
                                          className={styles.amountChip}
                                        />
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        <Chip
                                          label={user.type}
                                          color="secondary"
                                          variant="outlined"
                                          size="small"
                                        />
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                          <Button
                                            variant="contained"
                                            color={getButtonColor(user.type) as any}
                                            onClick={() =>
                                              user.type === "accountPost" || user.type === "tellerPost"
                                                ? handleOpenDialog(user.activityID, "approve", user.type, user.amount)
                                                : handleOpenDialogO(user.activityID, "approve", user.type, user.amount)
                                            }
                                            className={styles.actionButton}
                                            startIcon={<CheckCircleIcon />}
                                          >
                                            Approve
                                          </Button>
                                          <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={() =>
                                              user.type === "accountPost" || user.type === "tellerPost"
                                                ? handleOpenDialog(user.activityID, "reject", user.type, user.amount)
                                                : handleOpenDialogO(user.activityID, "reject", user.type, user.amount)
                                            }
                                            className={styles.actionButton}
                                            startIcon={<CancelIcon />}
                                          >
                                            Reject
                                          </Button>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  </Grow>
                                );
                              }
                              return null;
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50]}
                      component="div"
                      count={filteredUsers.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className={styles.pagination}
                    />
                  </Box>
                </Zoom>
              ) : (
                <Fade in={true} timeout={500}>
                  <Box className={styles.emptyState}>
                    <PaymentIcon className={styles.emptyIcon} />
                    <Typography variant="h6" className={styles.emptyText}>
                      No Pending Approvals
                    </Typography>
                    <Typography variant="body2" className={styles.emptySubtext}>
                      All payment requests have been processed
                    </Typography>
                  </Box>
                </Fade>
              )}
            </Paper>
          </Grow>
        </Container>

        {/* Dialogs */}
        <Dialog
          open={openDialogO}
          onClose={handleCloseDialog}
          PaperProps={{ className: styles.dialogPaper }}
          TransitionComponent={Fade}
        >
          <DialogTitle className={styles.dialogTitle}>
            <WarningIcon className={styles.dialogIcon} />
            Confirm {actionType === "approve" ? "Payment Approval" : "Rejection"}
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Typography variant="body1" className={styles.dialogText}>
              Are you sure you want to {actionType} this payment request?
            </Typography>
            {actionType === "approve" && (
              <FormControl fullWidth className={styles.formControl} sx={{ mt: 2 }}>
                <InputLabel>Select Account to Pay With</InputLabel>
                <Select
                  value={paywithValue}
                  label="Select Account to Pay With"
                  onChange={(e) => setPaywithValue(e.target.value)}
                  className={styles.select}
                >
                  {paymentList.map((payment) => (
                    <MenuItem key={payment.id} value={payment.sn} className={styles.menuItem}>
                      {payment.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions className={styles.dialogActions}>
            <Button onClick={handleCloseDialog} className={styles.cancelButton} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmActionO}
              className={actionType === "approve" ? styles.confirmButton : styles.rejectButton}
              variant="contained"
              disabled={actionType === "approve" && !paywithValue}
            >
              {actionType === "approve" ? "Approve Payment" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperProps={{ className: styles.dialogPaper }}
          TransitionComponent={Fade}
        >
          <DialogTitle className={styles.dialogTitle}>
            <WarningIcon className={styles.dialogIcon} />
            Confirm {actionType === "approve" ? "Approval" : "Rejection"}
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Typography variant="body1" className={styles.dialogText}>
              Are you sure you want to {actionType} this request?
            </Typography>
          </DialogContent>
          <DialogActions className={styles.dialogActions}>
            <Button onClick={handleCloseDialog} className={styles.cancelButton} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              className={actionType === "approve" ? styles.confirmButton : styles.rejectButton}
              variant="contained"
            >
              {actionType === "approve" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        <IonLoading
          message="Processing..."
          spinner="circles"
          isOpen={status.loading}
          className={styles.loading}
        />
      </IonContent>
    </IonPage>
  );
};

export default PaymentApproval;
